import React, { useEffect, useRef } from 'react';

const activities = [
  {
    date: 'March 2026',
    title: 'Bilateral Business Forum 2026',
    desc: 'Hosted over 120 delegates from Italian and Bangladeshi enterprises at the Radisson Blu Dhaka for two days of sector-specific B2B meetings and signing ceremonies.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20forum%20conference%20hall%20with%20delegates%20seated%20at%20round%20tables%2C%20Bangladesh%20and%20Italian%20flags%20visible%2C%20elegant%20modern%20hotel%20conference%20room%20with%20stage%20lighting%2C%20warm%20ambient%20tones%2C%20realistic%20corporate%20event%20photography%20style&width=600&height=400&seq=act1&orientation=landscape',
    tag: 'Flagship Event',
  },
  {
    date: 'January 2026',
    title: 'Trade Mission to Milan',
    desc: 'Led a delegation of 18 Bangladeshi textile and leather manufacturers to Milan to explore partnerships with Italian buyers and fashion houses.',
    image: 'https://readdy.ai/api/search-image?query=Business%20delegation%20visiting%20modern%20Milan%20fashion%20district%20showroom%2C%20Bangladeshi%20and%20Italian%20businessmen%20shaking%20hands%20in%20elegant%20showroom%20with%20fabric%20samples%20and%20Italian%20architecture%20visible%20through%20windows%2C%20warm%20professional%20photography&width=600&height=400&seq=act2&orientation=landscape',
    tag: 'Trade Mission',
  },
  {
    date: 'November 2025',
    title: 'Policy Dialogue on Green Trade',
    desc: 'Organized a roundtable with Ministry of Commerce officials and Italian sustainability consultants to draft joint green trade guidelines.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20policy%20roundtable%20discussion%20in%20modern%20conference%20room%2C%20Bangladeshi%20government%20officials%20and%20Italian%20consultants%20seated%20around%20circular%20table%20with%20documents%20and%20microphones%2C%20soft%20warm%20lighting%2C%20corporate%20photography%20style&width=600&height=400&seq=act3&orientation=landscape',
    tag: 'Policy',
  },
  
  
];

// --- Shared Reveal Logic ---
function useReveal() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.querySelectorAll<HTMLElement>('[data-r]').forEach((node, i) => {
            setTimeout(() => {
              node.style.opacity = '1';
              node.style.transform = 'translateY(0) translateX(0)';
            }, i * 120);
          });
          obs.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

const hide = (dir: 'up' | 'left' | 'right' = 'up'): React.CSSProperties => ({
  opacity: 0,
  transform:
    dir === 'up' ? 'translateY(28px)'
    : dir === 'left' ? 'translateX(-32px)'
    : 'translateX(32px)',
  transition: 'opacity 0.8s ease, transform 0.8s ease',
});
// ---------------------------

export default function ActivitySection() {
  const sectionRef = useReveal();

  return (
    <section id="activity" className="py-20 md:py-24 bg-white font-sans">
      <div ref={sectionRef} className="w-full px-6 md:px-10 lg:px-16 xl:px-24 max-w-[1400px] mx-auto">
        
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 md:mb-10">
          

          <h2 
            data-r 
            style={{
              ...hide('up'),
              color: '#0F1C35',
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: 800,
              letterSpacing: '-0.02em'
            }}
            className="mb-6"
          >
            Activity
          </h2>
          
         
        </div>

        {/* Activity Grid */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {activities.map((act, i) => (
            <div
              key={i}
              data-r
              // FIX: Only one style block used here now
              className="group bg-white rounded-2xl overflow-hidden border transition-all duration-300 hover:-translate-y-1 hover:shadow-xl cursor-pointer flex flex-col"
              style={{ borderColor: '#E5E7EB', ...hide('up') }}
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={act.image}
                  alt={act.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
                <div className="absolute top-4 left-4">
                  <span 
                    className="px-3 py-1.5 bg-white/95 backdrop-blur-md text-[10px] font-bold uppercase tracking-wider rounded-full shadow-sm" 
                    style={{ color: '#0F1C35' }}
                  >
                    {act.tag}
                  </span>
                </div>
              </div>
              
              <div className="p-6 md:p-8 flex flex-col flex-grow">
                <span className="text-[11px] font-bold text-gray-400 mb-3 block uppercase tracking-wide">
                  {act.date}
                </span>
                
                <h3 
                  className="text-lg md:text-xl font-bold mb-3 line-clamp-2 leading-snug transition-colors group-hover:text-[#C9952A]" 
                  style={{ color: '#0F1C35' }}
                >
                  {act.title}
                </h3>
                
                <p 
                  className="text-sm leading-relaxed mb-6 flex-grow" 
                  style={{ color: '#3D4A62' }}
                >
                  {act.desc}
                </p>
                
                <div className="w-full h-[1px] bg-gray-100 mb-4 mt-auto"></div>
                
                <span 
                  className="inline-flex items-center gap-2 text-sm font-bold transition-colors text-[#C9952A] group-hover:text-[#C9952A]" 
                  style={{ color: '#0F1C35' }}
                >
                  View Details
                  <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </span>
              </div>
            </div>
          ))}
        </div> */}
        <div className='flex items-center justify-center h-[60%] text-2xl font-bold'>
          <h2>Activity Update is Coming Soon</h2>
        </div>

      </div>
    </section>
  );
}